import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormStepComponentProps } from 'components/Forms/MultiStepForm';
import { CharacterizationForm } from 'types';

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  firstFieldLine: {
    paddingBottom: 15,
  },
  fieldLine: {
    marginTop: 8,

    '& > div': {
      minWidth: 470,
    },

    '& span': {
      fontSize: 18,
      marginBottom: 5,
    },
  },
  sharedLine: {
    display: 'flex',
    justifyContent: 'space-between',

    '& > div': {
      width: 214,
    },
  },
  materialTable: {
    width: 470,
  },
  materialWeightCell: {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    width: '50%',
    padding: '1px 13px',
  },
  materialNameCell: {
    padding: '6.5px 22px',
  },
  materialLabel: {
    fontSize: 'inherit',
    color: 'inherit',
  },
  totalWeightCell: {
    padding: '7.5px 13px',
  },
  totalWeightField: {
    width: 171,
    textAlign: 'right',
    padding: 0,
  },
  headerCell: {
    borderTop: '1px solid rgba(224, 224, 224, 1)',
    padding: '11px 22px',
  },
});
const Step3: React.FC<FormStepComponentProps<CharacterizationForm>> = ({ onSubmit, formName, previousStepData }) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'characterizationForm' });

  const { control, handleSubmit } = useForm<CharacterizationForm>({
    mode: 'onBlur',
    defaultValues: previousStepData,
  });

  return (
    <form id={formName} onSubmit={handleSubmit(onSubmit)} className={classes.form}>
      <div className={classes.fieldLine}>
        <FormControl>
          <Controller
            name="secteur"
            control={control}
            render={({ field: { ref, ...inputProps }, fieldState }) => (
              <TextField
                className={classes.firstFieldLine}
                label={t('secteur')}
                inputRef={ref}
                variant="outlined"
                {...inputProps}
                helperText={fieldState.error?.message}
                error={fieldState.invalid}
              />
            )}
          />
          <Controller
            name="comment"
            control={control}
            render={({ field: { ref, ...inputProps }, fieldState }) => (
              <TextField
                label={t('comment')}
                inputRef={ref}
                multiline
                rows={6}
                variant="outlined"
                {...inputProps}
                helperText={fieldState.error?.message}
                error={fieldState.invalid}
              />
            )}
          />
        </FormControl>
      </div>
    </form>
  );
};

export default Step3;
